export function OutlineSelectIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 6V5.0016C22 3.9024 21.1024 3 19.9984 3H19"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M19 21H19.9984C21.0976 21 22 20.0976 22 18.9984V18"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M4 18V18.9984C4 20.0976 4.9024 21 6.0016 21H7"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M7 3H6.0016C4.9024 3 4 3.8976 4 5.0016V6"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M8.80005 12.6L11.2 15L17.2 9"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4 9.99805V14.0012" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M10.9985 21H15.0017" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M10.9985 3H15.0017" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M22 14.0012V9.99805" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
